import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { ROUTES_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
const store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: ROUTES_QUERY,
    fetchAllFieldName: 'shipRoutes',
  },
})
/* eslint-enable no-unused-vars */

export default store

